// chat-delegated-attribution.ts — 06k C9 (D2, bất biến 2): một nguồn cho cách
// ghi + hiển thị quyết định/duyệt do phiên chat Claude Code làm THAY chủ mission.
// Ủy nhiệm không bao giờ hiển thị như người duyệt: nhãn cố định
// "Claude thay chủ mission (qua chat)". Tiền tố actor `chat_delegated:` KHÔNG va
// `delegated:` (quyền G0 auto do controller tự áp — I6).
import type { Directive } from "./schemas/directive-schema.js";

export const CHAT_DELEGATED_SOURCE = "chat_delegated";
export const CHAT_DELEGATED_LABEL = "Claude thay chủ mission (qua chat)";
const ACTOR_PREFIX = `${CHAT_DELEGATED_SOURCE}:`;

/** `chat_delegated:<os account>` — actor của câu trả lời ủy nhiệm (E37). */
export function chatDelegatedActor(osAccount: string): string {
  return `${ACTOR_PREFIX}${osAccount}`;
}

export function isChatDelegatedActor(actor: string): boolean {
  return actor.startsWith(ACTOR_PREFIX);
}

/** Hiển thị local (terminal/status): ủy nhiệm ⇒ nhãn + actor gốc; nguồn khác giữ nguyên. */
export function formatDecisionSource(source: string): string {
  return isChatDelegatedActor(source) ? `${CHAT_DELEGATED_LABEL} (${source})` : source;
}

/** Actor ghi vào interview/journal cho một directive answer (C8). */
export function directiveDecisionActor(directive: Pick<Directive, "source" | "actor_id">): {
  answeredBy: string;
  journalActor: string;
} {
  return directive.source === CHAT_DELEGATED_SOURCE
    ? {
        answeredBy: chatDelegatedActor(directive.actor_id),
        journalActor: chatDelegatedActor(directive.actor_id),
      }
    : { answeredBy: directive.actor_id, journalActor: `user:${directive.actor_id}` };
}
